<template>
  <div class="xxb-main">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="类型">
              <el-select v-model="searchForm.type" clearable style="width: 100px">
                <el-option label="URL" :value="0"></el-option>
                <el-option label="课程" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.mark" clearable style="width: 100px">
                <el-option label="启用" :value="1"></el-option>
                <el-option label="停用" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加Banner</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="xuhao"
                label="序号"
                width="50"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="图片"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img_url"
                    fit="cover"
                    style="width: 80px;height: 40px;"
                    :preview-src-list="[scope.row.img_url]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                label="内容"
                min-width="160"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <div v-if="scope.row.type===0">{{scope.row.url}}</div>
                  <div v-if="scope.row.type===1">{{scope.row.cname}}</div>
                  <div style="font-size: 12px;color:#909399">
                    <span style="color:#409EFF" v-if="scope.row.type===0"><i class="el-icon-link"></i> 网址</span>
                    <span style="color:#E6A23C" v-if="scope.row.type===1"><i class="el-icon-collection"></i> 课程
                    <span style="color:#409EFF" v-if="scope.row.ctype===0"><i class="el-icon-video-play"></i> 视频</span>
                    <span style="color:#E6A23C" v-if="scope.row.ctype===1"><i class="el-icon-headset"></i> 音频</span>
                    <span style="color:#67C23A" v-if="scope.row.ctype===2"><i class="el-icon-reading"></i> 电子书</span>
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                align="center"
                width="60">
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="primary">启用</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0" type="danger">停用</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="rules">
        <el-form-item label="序号" prop="xuhao">
          <el-input-number v-model="editForm.xuhao" :min="0" :max="999" ></el-input-number>
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">越小越优先</span>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio v-model="editForm.type" :label="0">URL</el-radio>
          <el-radio v-model="editForm.type" :label="1">课程</el-radio>
        </el-form-item>
        <el-form-item label="网址URL" prop="url" v-if="editForm.type===0">
          <el-input v-model="editForm.url" maxlength="1500" placeholder="请输入网址URL" show-word-limit>
          </el-input>
        </el-form-item>
<!--        <el-form-item label="课程" prop="cid" v-if="editForm.type==1">-->
<!--          <el-select v-model="editForm.cid" filterable placeholder="请选择" style="width: 500px">-->
<!--            <el-option-->
<!--              v-for="item in courseData"-->
<!--              :key="item.cid"-->
<!--              :label="item.cname"-->
<!--              :value="item.cid">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="选择课程" prop="cid" v-if="editForm.type===1">
          <CourseSelect  v-model="editForm.cid" :oldcid="editForm.oldcid" :key="courseKey" ></CourseSelect>
        </el-form-item>
        <el-form-item label="状态" prop="mark">
          <el-radio v-model="editForm.mark" :label="1">启用</el-radio>
          <el-radio v-model="editForm.mark" :label="0">停用</el-radio>
        </el-form-item>
        <el-form-item label="图片" prop="img">
          <span style="color:#99a9bf;font-size: 12px;"><i class="el-icon-info"></i> 图片建议尺寸1280*800px</span>
          <SingleImg :key="imgKey" v-model="editForm.img" :oldurl="editForm.oldImg_url" :size="[320,200]"></SingleImg>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import { getUser } from '@/utils/auth'
import { getBannerList, editBanner, delBanner } from '@/api/work'
import { getCourseList } from '@/api/study/course'
import SingleImg from '@/components/upload/SingleImg'
import CourseSelect from '@/components/CourseSelect/CourseSelect'
export default {
  name: "xxb",
  components: { CourseSelect, SingleImg },
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        type: null,
        mark: null,
        search: ''
      },
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      editForm: {
        bid: null,
        img: null,
        xuhao: 0,
        type: 0,
        url: '',
        cid: '',
        ctype: '',
        mark: 1,
        oldImg_url: '',
        oldcid: ''
      },
      rules: {
        url: [{ required: true, message: '请输入网址', trigger: 'blur' }],
        cid: [{ required: true, message: '请选择课程', trigger: 'change' }],
        img: [{ required: true, message: '请上传图片', trigger: 'change' }]
      },
      courseData: [],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      imgKey: '',
      courseKey: ''
    }
  },
  created() {
    this.getData()
    this.getCourseData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        type: this.searchForm.type,
        mark: this.searchForm.mark,
        search: this.searchForm.search
      }
      getBannerList(data).then(response => {
        this.loading = false
        this.tableData = response.data.data
        this.total = response.data.total
      }).catch(() => {
        this.loading = false
      })
    },
    getCourseData() {
      const data = {
        page: 1,
        limit: 99999
      }
      getCourseList(data).then(response => {
        this.courseData = response.data
      })
    },
    editRow(row) {
      this.imgKey = new Date().getTime()
      this.courseKey = new Date().getTime()
      if (row == null) {
        this.editTitle = '添加学习Banner'
        this.editForm.bid = null
        this.editForm.img = null
        this.editForm.xuhao = 0
        this.editForm.type = 0
        this.editForm.url = ''
        this.editForm.cid = ''
        this.editForm.ctype = ''
        this.editForm.mark = 1
        this.editForm.oldImg_url = ''
        this.editForm.oldcid = null
      } else {
        this.editTitle = '修改学习Banner'
        this.editForm.bid = row.bid
        this.editForm.img = { imgid: row.imgid, imgurl: row.img_url }
        this.editForm.xuhao = row.xuhao
        this.editForm.type = row.type
        this.editForm.url = row.url
        this.editForm.cid = { cid: row.cid }
        this.editForm.ctype = row.ctype
        this.editForm.mark = row.mark
        this.editForm.oldImg_url = row.img_url
        this.editForm.oldcid = row.cid
      }
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            let data = {}
            if (this.editForm.type === 0) {
              data = {
                bid: this.editForm.bid,
                imgid: this.editForm.img.imgid,
                xuhao: this.editForm.xuhao,
                type: this.editForm.type,
                url: this.editForm.url,
                cid: null,
                ctype: null,
                mark: this.editForm.mark
              }
            } else {
              data = {
                bid: this.editForm.bid,
                imgid: this.editForm.img.imgid,
                xuhao: this.editForm.xuhao,
                type: this.editForm.type,
                url: null,
                cid: this.editForm.cid.cid,
                ctype: this.editForm.cid.type,
                mark: this.editForm.mark
              }
            }
            this.eidtLoading = true
            editBanner(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.Search()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delBanner({ bid: row.bid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .xxb-main{
  }
</style>
